<div class="legal-data-container">
	<div class="legal-data-header">
		<copo-back-button></copo-back-button>
		<span translate>legal.data.header</span>
	</div>
	<div class="block legal-data-top-container">
		<copo-legal-documents></copo-legal-documents>
	</div>
	<copo-legal-privacy-policy></copo-legal-privacy-policy>
	<div class="settings-version">
		{{ buildNumber }}
	</div>
</div>
